import { combineReducers } from "redux";
import Auth from "./Auth";
import Theme from "./Theme";
import Role from "./Role";
import AgencyTests from "./AgencyTests";
import User from "./User";
import Coupon from "./Coupon";
import Section from "./Section";
import Machine from "./Machine";
import Equipment from "./Equipment";
import CheckList from "./CheckList";
import Maintenance from "./Maintenance";
import Department from "./Department";
import Appointment from "./Appointment";
import storage from "redux-persist/lib/storage";
import BranchLookUp from "./BranchLookUp";
import TestDirectory from "./TestDirectory";
import DiscontinuedTestDirectoryService from "./DiscontinuedTestDirectories";
import TestRegistration from "./TestRegistration";
import Patient from "./Patient";
import ClientCompany from "./ClientCompany";
import BranchTestCapacity from "./BranchTestCapacity";
import ClientCompanyTestDirectory from "./ClientCompanyTestDirectory";
import newOrder from "./NewOrder";
import OrderMadeByGuestUsers from "./OrderMadeByGuestUsers";
import InPersonDelivery from "./InPersonDeliver";
import Financials from "./Financials";
import { persistReducer } from "redux-persist";
import Notyetreleased from "./Notyetreleased";
import Released from "./Released";
import SampleAccepted from "./SampleAccepted";
import PatientResult from "./PatientResult";
import IncompleteResults from "./IncompleteResults";
import Discrepancy from "./Discrepancy";
import DiscrepancyApproved from "./DiscrepanciesStatus/DiscrepancyApproved";
import DiscrepancyDeclined from "./DiscrepanciesStatus/DiscrepancyDeclined";
import DiscrepancyPending from "./DiscrepanciesStatus/DiscrepancyPending";
import ApprovedOrders from "./OrderStatus/ApprovedOrders";
import DeclinedOrders from "./OrderStatus/DeclinedOrders";
import PendingOrders from "./OrderStatus/PendingOrders";
import StatOrders from "./StatOrders";
import AllOrders from "./OrderStatus/AllOrders";
import TopAgencies from "./TopAgencies";
import TopTests from "./TopTests";
import PendingResultsObx from "./PendingResultsObx";
import topPanels from "./TopPanels";
import DashboardReports from "./AdminDashboardReports/DashboardReports";
import TopBranchesForWalkinCustomers from "./TopBranchesForWalkinCustomer";
import PanicandAbnormalTestResults from "./PanicandAbnormalTestResults";
import PatientTestResultHistory from "./PatientTestResultHistory";
import PatientSearch from "./PatientsSearch";
import UploadFile from "./UploadFile";
import MicroBiology from "./MicroBiology";
import IclPay from "./IclPay";
import DailyReleasedTests from "./DailyReleasedTests";
import SingleReleasedDailyReleasedTests from "./SingleReleasedDailyReleasedTests";
import DailyDepartmentReleasedTests from "./DailyDepartmentReleasedTests";
import CompletedResults from "./CompletedResults";
import { SampleInProcess } from "./SampleInProcess";
import FaultResults from "./FaultResults";
import ReferableOrders from "./ReferableOrders";
import TestobxPerTechnician from "./TestObxPerTechnician";
import TatApproaching from "./TATApproaching";
import SiteNames from "./AdminDashboardReports/SiteNames";
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["appointment", "branchLookUp"],
};

const reducers = combineReducers({
  theme: Theme,
  role: Role,
  agencyTests: AgencyTests,
  user: User,
  coupon: Coupon,
  section: Section,
  machine: Machine,
  equipment: Equipment,
  checkList: CheckList,
  maintenance: Maintenance,
  auth: Auth,
  department: Department,
  appointment: Appointment,
  branchLookUp: BranchLookUp,
  testDirectory: TestDirectory,
  discontinuedTestDirectoryService: DiscontinuedTestDirectoryService,
  testRegistration: TestRegistration,
  patient: Patient,
  branchTestCapacity: BranchTestCapacity,
  clientCompany: ClientCompany,
  clientCompanyTestDirectory: ClientCompanyTestDirectory,
  newOrder: newOrder,
  orderMadeByGuestUsersState: OrderMadeByGuestUsers,
  inPersonDelivery: InPersonDelivery,
  financial: Financials,
  notyetreleaseds: Notyetreleased,
  sampleInProcess: SampleInProcess,
  releaseds: Released,
  sampleAccepted: SampleAccepted,
  patientresult: PatientResult,
  completedResults: CompletedResults,
  incompleteResults: IncompleteResults,
  discrepancy: Discrepancy,
  discrepancyApproved: DiscrepancyApproved,
  discrepancyDeclined: DiscrepancyDeclined,
  discrepancyPending: DiscrepancyPending,
  approvedOrders: ApprovedOrders,
  declinedOrders: DeclinedOrders,
  pendingOrders: PendingOrders,
  statOrders: StatOrders,
  allOrders: AllOrders,
  topagencies: TopAgencies,
  toptests: TopTests,
  pendingResultsObx: PendingResultsObx,
  dashboardReports: DashboardReports,
  topPanels: topPanels,
  topBranchesForWalkinCustomers: TopBranchesForWalkinCustomers,
  panicandabnormaltestresults: PanicandAbnormalTestResults,
  patientTestResultHistory: PatientTestResultHistory,
  patientSearch: PatientSearch,
  uploadFile: UploadFile,
  microBiology: MicroBiology,
  iclPay: IclPay,
  dailyReleasedTests: DailyReleasedTests,
  dailyDepartmentReleasedTests: DailyDepartmentReleasedTests,
  singleReleasedDailyReleasedTests: SingleReleasedDailyReleasedTests,
  faultResults: FaultResults,
  referableOrders: ReferableOrders,
  tesObxPerTechnician: TestobxPerTechnician,
  tatApproaching : TatApproaching,
  siteNames:SiteNames
});

export default persistReducer(persistConfig, reducers);
